// ============================================================================
// INVESTMENT DASHBOARD REPOSITORY
// ARQUIVO: src/features/finance/InvestmentDashboardRepository.js
// RESPONSABILIDADE: Isolar todas as chamadas Firestore do InvestmentDashboard.
// ============================================================================

import {
  collection, addDoc, updateDoc, deleteDoc, doc, onSnapshot, serverTimestamp, query, orderBy
} from 'firebase/firestore';
import { db } from '../../shared/api/firebase/config';
import { FIREBASE_CONFIG } from '../../config/Config';

const appId = FIREBASE_CONFIG.projectId;
const COL_PATH = ['artifacts', appId, 'public', 'data', 'investments'];

export const subscribeInvestments = (callback) => {
  const colRef = collection(db, ...COL_PATH);
  const q = query(colRef, orderBy('createdAt', 'desc'));
  return onSnapshot(q, (snap) => {
    const list = snap.docs.map(d => ({ id: d.id, ...d.data() }));
    callback(list);
  }, (err) => {
    console.error('[Investments] Firestore error:', err);
  });
};

export const addInvestment = async (data) => {
  const colRef = collection(db, ...COL_PATH);
  return addDoc(colRef, { ...data, createdAt: serverTimestamp(), updatedAt: serverTimestamp() });
};

export const updateInvestment = async (id, data) => {
  const ref = doc(db, ...COL_PATH, id);
  return updateDoc(ref, { ...data, updatedAt: serverTimestamp() });
};

export const deleteInvestment = async (id) => {
  const ref = doc(db, ...COL_PATH, id);
  return deleteDoc(ref);
};
